interface IsHardNavigateSameUrlErrorParams {
  message: string
}

/**
 * Next's router throws this invariant (`node_modules/next/.../router.ts`, error code E282) when a
 * client navigation resolves to a *hard* navigation whose target equals the current `asPath` — it
 * throws instead of reloading to avoid an infinite refresh loop. In practice this fires on a stale
 * (superseded) build after a deploy: `getRouteInfo` can't fetch the rotated `_next/data`, so
 * `handleRouteInfoError` falls back to a hard nav to the page the user is already on. The throw is
 * async router-internal — it bypasses every React error boundary and surfaces as an unhandled
 * rejection — but it is a benign, self-recovering deploy artifact, not an actionable fault.
 */
const HARD_NAVIGATE_SAME_URL_ERROR_MESSAGE = 'attempted to hard navigate to the same URL'

export const isHardNavigateSameUrlError = ({ message }: IsHardNavigateSameUrlErrorParams): boolean =>
  message.includes(HARD_NAVIGATE_SAME_URL_ERROR_MESSAGE)
